module.exports = __webpack_public_path__ + "img/tombstone-blank.be9a3468.svg";